import { IMAGES } from "./products";

export const benefits = [
  {
    title: "Free Home Consultation",
    text: "See fabrics, colours and finishes in your own home, in your own light.",
    icon: "Home",
  },
  {
    title: "Expert Measuring",
    text: "Professional measurements for the right fit, first time.",
    icon: "Ruler",
  },
  {
    title: "Made Just for You",
    text: "Every blind or shutter is made for your individual windows.",
    icon: "Scissors",
  },
  {
    title: "Professional Installation",
    text: "Installation completed by experienced fitters who tidy up after themselves.",
    icon: "Wrench",
  },
];

export const steps = [
  {
    n: "01",
    title: "Book Your Free Visit",
    text: "Choose a convenient appointment and tell us what you're looking for.",
  },
  {
    n: "02",
    title: "Measure & Design",
    text: "A specialist measures your windows and helps you compare styles, fabrics and finishes.",
  },
  {
    n: "03",
    title: "Receive Your Quote",
    text: "Receive a clear, no-obligation quotation for your selected products.",
  },
  {
    n: "04",
    title: "We Fit Everything",
    text: "Your made-to-measure products are professionally installed and checked.",
  },
];

export const homeFaqs = [
  {
    q: "Is the home design visit free?",
    a: "Yes — completely free and without obligation. A specialist visits at a time that suits you, brings samples, measures your windows and leaves you with a clear written quotation. There is no pressure to order.",
  },
  {
    q: "Do you measure the windows for me?",
    a: "Always. Accurate measuring is part of the service and one of the main reasons customers choose us over ordering online. We account for recess depth, handles, tiles and bay angles so your blinds fit exactly.",
  },
  {
    q: "Do you install the blinds?",
    a: "Yes. Your blinds are fitted by experienced fitters who check everything operates smoothly, fit child-safety devices where required, and take all packaging away.",
  },
  {
    q: "How long do made-to-measure blinds take?",
    a: "Timescales vary by product and fabric, and we will give you an honest estimate at quotation. Your fitter then books an installation appointment that suits you as soon as your order is ready.",
  },
  {
    q: "What types of blinds do you offer?",
    a: "Roller, roman, venetian, vertical, day & night, Perfect Fit, motorised, skylight and blackout & thermal blinds — plus made-to-measure shutters. Every product is made to your exact measurements.",
  },
  {
    q: "Can I see samples before ordering?",
    a: "That is the whole point of the home visit. You can see and feel real fabric and material samples against your décor, in the actual light of the room they are intended for.",
  },
  {
    q: "Do you supply shutters?",
    a: "Yes — we design, measure and fit made-to-measure shutters. See our shutters page, or book a free shutter consultation and we will talk you through styles and finishes at home.",
  },
  {
    q: "Do you offer motorised blinds?",
    a: "Yes. Most roller, day & night and roman blinds can be motorised with quiet, rechargeable battery motors, controlled by remote, app or smart-home system.",
  },
  {
    q: "What areas do you cover?",
    a: "We're a Birmingham company working right across the city and the wider West Midlands — from Harborne and Edgbaston to Sutton Coldfield and Solihull. If you are nearby and unsure, send us your postcode and we will confirm straight away.",
  },
  {
    q: "Can you provide blinds for businesses and commercial properties?",
    a: "Yes. We work with offices, shops, schools and other commercial premises, with durable, practical ranges suited to heavier use. Contact us to discuss your requirements.",
  },
];

// Genuine Google reviews supplied by the business.
export const reviews = [
  {
    name: "Stow Watches",
    rating: 5,
    text: "We had a fantastic experience with this blinds company. From the initial consultation to the final installation, everything was smooth and professional. The staff were helpful in choosing the right style and colour, and the quality of the blinds exceeded our expectations.",
    source: "Google review",
  },
  {
    name: "Aliya Khan",
    rating: 5,
    text: "Great service from beginning to end. The measurements were taken quickly, and my blinds were installed within a week. I'm really happy with how everything turned out and would definitely recommend this company.",
    source: "Google review",
  },
  {
    name: "Elias Abraham",
    rating: 5,
    text: "I'm very happy with My Blinds Company and the work they've done — absolutely professional, the price is good and they are friendly. They're very good at what they do. Thanks!",
    source: "Google review",
  },
];

// Portfolio entries — real installation photography will replace these illustrations.
export const projectFilters = [
  "All",
  "Blinds",
  "Shutters",
  "Living Room",
  "Bedroom",
  "Kitchen",
  "Bay Windows",
  "Motorised",
];

export const projects = [
  { title: "Roller blinds", room: "Living Room", tags: ["Blinds", "Living Room"], image: IMAGES.livingRoom, product: "Roller Blinds" },
  { title: "Roman blinds", room: "Bedroom", tags: ["Blinds", "Bedroom"], image: IMAGES.bedroom, product: "Roman Blinds" },
  { title: "Perfect Fit blinds", room: "Kitchen", tags: ["Blinds", "Kitchen"], image: IMAGES.kitchen, product: "Perfect Fit Blinds" },
  { title: "Roman blinds", room: "Bay Window", tags: ["Blinds", "Bay Windows"], image: IMAGES.bayWindow, product: "Roman Blinds" },
  { title: "Full-height shutters", room: "Living Room", tags: ["Shutters", "Living Room"], image: IMAGES.shutters, product: "Shutters" },
  { title: "Venetian blinds", room: "Bathroom", tags: ["Blinds"], image: IMAGES.venetian, product: "Venetian Blinds" },
  { title: "Motorised roller blinds", room: "Open-plan space", tags: ["Blinds", "Motorised"], image: IMAGES.motorised, product: "Motorised Blinds" },
  { title: "Day & night blinds", room: "Dining Room", tags: ["Blinds"], image: IMAGES.daynight, product: "Day & Night Blinds" },
  { title: "Shutters in a sunroom", room: "Conservatory", tags: ["Shutters"], image: IMAGES.shuttersSunroom, product: "Shutters" },
  { title: "Skylight blinds", room: "Loft Bedroom", tags: ["Blinds", "Bedroom"], image: IMAGES.skylight, product: "Skylight Blinds" },
];

export const whyPoints = [
  {
    title: "Advice in your own home",
    text: "We bring the showroom to you. Compare real samples against your décor, in the light the blinds will actually live in — not under showroom spotlights.",
  },
  {
    title: "Measured by professionals",
    text: "No tape-measure guesswork. We measure precisely, accounting for recesses, handles, tiles and bay angles, so nothing arrives the wrong size.",
  },
  {
    title: "A genuinely wide choice",
    text: "Hundreds of fabrics, materials, colours and finishes across every blind type — plus made-to-measure shutters — without being locked to one range.",
  },
  {
    title: "Made to measure, always",
    text: "Nothing comes off a shelf. Every blind and shutter is manufactured to the exact measurements of your windows.",
  },
  {
    title: "Fitted and finished properly",
    text: "Experienced fitters install everything, check the operation, fit child-safety devices and take the packaging away.",
  },
  {
    title: "Clear, no-obligation quotes",
    text: "One clear written quotation after your visit. No pressure, no inflated 'discounts', no surprise extras later.",
  },
  {
    title: "Appointments that suit you",
    text: "Evening and weekend visits can be arranged around work and family life — including Saturdays by appointment.",
  },
  {
    title: "Aftercare you can reach",
    text: "We are a local Birmingham business. If you need an adjustment or advice after fitting, you call us and speak to a person.",
  },
];

export const leadFormOptions = {
  interests: [
    "Roller Blinds",
    "Venetian Blinds",
    "Vertical Blinds",
    "Wooden Blinds",
    "Roman Blinds",
    "Day & Night Blinds",
    "Perfect Fit Blinds",
    "Blackout Blinds",
    "Motorised Blinds",
    "Shutters",
    "Commercial Blinds",
    "Not Sure / Need Advice",
  ],
  rooms: [
    "Living Room",
    "Bedroom",
    "Kitchen",
    "Dining Room",
    "Conservatory",
    "Bay Window",
    "Whole House",
    "Commercial Property",
    "Other",
  ],
};
